"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagNotInitializedError = void 0;
/**
 * @deprecated
 *
 * The method will return a boolean instead of throw an error.
 */
class FeatureFlagNotInitializedError extends Error {
    constructor(value) {
        super(`Feature Flag has to be initialized before use it. Current value: ${value}`);
    }
}
exports.FeatureFlagNotInitializedError = FeatureFlagNotInitializedError;
//# sourceMappingURL=errors.js.map